// Écran central : message de situation + bouton d'action (Jouer / Niveau suivant / Recommencer, et à la fin de la partie
// Inscrire mon score)
import { $, show, hide, keepPunctuationAttached, setTextWithEmoji, haloClass } from './dom.js';
import { pickComment } from '../data/comments.js';
import { OVERLAY_BUTTON_DELAY_MS } from '../config/constants.js';

// La carte est claire (.dialog-card.is-light) : la phrase est en bleu nuit quelle que soit la situation, le bouton dit le reste
// (dégradé de la marque, or quand on a tenu, danger quand on a perdu)
const MESSAGE_COLOR = 'text-bg';

// Libellé des boutons : un simple verbe d'action, sans picto (clé i18n par situation)
const BUTTON_LABEL_KEYS = {
  start: 'overlay.button.start',
  win: 'overlay.button.win',
  survive: 'overlay.button.survive',
  lose: 'overlay.button.lose',
  champion: 'overlay.button.champion',
};

// Bouton d'action de la charte (.btn-cta) : dégradé de la marque, or quand on a tenu, danger quand on a perdu
const BUTTON_BASE = 'btn-cta px-6 py-4 text-xl md:text-2xl';
const BUTTON_STYLES = {
  start: '',
  win: '',
  survive: 'is-gold',
  lose: 'is-down',
  champion: 'is-gold', // l'or du Hall of Fame
};

// Phrase : picto au début et à la fin (convention de comments.js), rendus plus grands et en relief.
// Texte équilibré sur ses lignes (text-balance), ponctuation collée au mot qui la précède, emoji
// du milieu agrandis (« 🐭 prend le ❤️ de 🐱 »).
function renderMessage(el, phrase) {
  const m = /^(\S+)\s+(.*?)\s+(\S+)$/u.exec(phrase);
  if (!m || m[1] !== m[3]) {
    setTextWithEmoji(el, keepPunctuationAttached(phrase));
    return;
  }
  const picto = () => {
    const span = document.createElement('span');
    span.className = `picto ${haloClass(m[1])}`.trim();
    span.textContent = m[1];
    return span;
  };
  const text = document.createElement('span');
  text.className = 'text-balance';
  setTextWithEmoji(text, keepPunctuationAttached(m[2]));
  el.replaceChildren(picto(), text, picto());
}

/** @param {{ t: (key: string) => string, getLanguage: () => string }} i18n */
export function createOverlay({ t, getLanguage }) {
  const overlay = $('gameOverlay');
  const message = $('overlayMessage');
  const buttons = {
    start: $('btnStartGame'),
    next: $('btnNextLevelCenter'),
    restart: $('btnRestartCenter'),
    register: $('btnRegisterCenter'),
  };
  let timeout = null;

  /**
   * @param {'start'|'win'|'survive'|'lose'|'champion'} situation  champion : le dernier niveau est gagné
   * @param {'start'|'next'|'restart'|'register'} action bouton à afficher
   * @param {string} [phrase] message imposé (picto au début et à la fin), sinon une phrase de data/comments.js
   */
  function display(situation, action, phrase = pickComment(getLanguage(), situation)) {
    if (timeout) clearTimeout(timeout);
    Object.values(buttons).forEach(hide);

    // Phrase discrète (le bouton doit dominer) ; pictos mis en relief via .picto
    message.className = `text-base md:text-lg font-semibold mb-5 px-2 leading-snug min-h-[60px] flex items-center justify-center gap-3 text-center ${MESSAGE_COLOR}`;
    renderMessage(message, phrase);
    show(overlay);

    const btn = buttons[action];
    btn.innerText = t(BUTTON_LABEL_KEYS[situation]);
    btn.className = `${BUTTON_BASE} ${BUTTON_STYLES[situation]}`;

    const delay = situation === 'start' ? 0 : OVERLAY_BUTTON_DELAY_MS;
    timeout = setTimeout(() => show(buttons[action]), delay);
  }

  function close() {
    if (timeout) clearTimeout(timeout);
    hide(overlay);
  }

  return { display, close, buttons };
}
